import i18n from "./../shared/vue-i18n";


export function showSuccess(message, toast, timeout = 5000) {

	toast.success(i18n.t(message), {
		position: "bottom-right",
		timeout: timeout,
		closeOnClick: true,
		pauseOnFocusLoss: true,
		pauseOnHover: true,
		draggable: true,
		draggablePercent: 0.6,
		showCloseButtonOnHover: false,
		closeButton: "button",
		icon: true,
		rtl: false
	});
}

export function showError(message, toast) {

	toast.error(i18n.t(message), {
		position: "bottom-right",
		timeout: 5000,
		closeOnClick: true,
		pauseOnFocusLoss: true,
		pauseOnHover: true,
		draggable: true,
		draggablePercent: 0.6,
		showCloseButtonOnHover: false,
		closeButton: "button",
		icon: true,
		rtl: false
	});
}
